import { ListRow } from '@/modules/shared/components/list-row/ListRow'
import { formatListDate } from '@/modules/shared/helpers/locale'
import { type Message, MessageReadStatus, type MessageType } from '../../types/message.types'

import type { ReactNode } from 'react'

const messageIcons: Record<MessageType, ReactNode> = {
  Message: <ListRow.Icon icon={['fal', 'info']} />,
  PatientCommunication: <ListRow.Icon icon={['fal', 'message-dots']} />,
}

function stripHTML(html?: string) {
  return html?.replace(/<[^>]*>?/g, '')
}

// The line under the title: the message itself, or the last reply of a conversation.
function getDescription(message: Message) {
  switch (message.type) {
    case 'Message': {
      return stripHTML(message.body)
    }

    case 'PatientCommunication': {
      const lastMessage = message.messages.at(0)

      return lastMessage?.content ? stripHTML(lastMessage.content) : ''
    }

    default: {
      return ''
    }
  }
}

type MessageItemProps = {
  message: Message
}

export const MessageItem = ({ message }: MessageItemProps) => (
  <ListRow>
    <ListRow.Badge>{messageIcons[message.type]}</ListRow.Badge>
    <ListRow.Title>{message.title}</ListRow.Title>
    {message.readStatus === MessageReadStatus.Unread ? <ListRow.UnreadDot /> : null}
    <ListRow.Description>{getDescription(message)}</ListRow.Description>
    <ListRow.Meta>{message.date ? formatListDate(message.date) : ''}</ListRow.Meta>
  </ListRow>
)
